module.exports = __webpack_public_path__ + "img/photo-2.de125d12.jpg";